import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { TenantService } from './tenant.service';
import { normalizePagedResponse } from '../utils/response.utils';

@Injectable({ providedIn: 'root' })
export class AllergensService {
  private get base(): string { return `${this.tenant.apiBaseUrl}/v1/tenant`; }

  constructor(private http: HttpClient, private tenant: TenantService) {}

  // List allergens
  // GET /v1/tenant/allergens
  list(params?: any): Observable<any> {
    return this.http.get<any>(`${this.base}/allergens`, { params }).pipe(
      map(res => {
        const pg = res?.data ?? res;
        const items: any[] = Array.isArray(pg?.data) ? pg.data : [];
        return {
          data: items,
          meta: {
            current_page: pg?.current_page ?? 1,
            last_page:    pg?.last_page    ?? 1,
            per_page:     pg?.per_page     ?? items.length,
            total:        pg?.total        ?? items.length,
          }
        };
      })
    );
  }

  // Create allergen
  // POST /v1/tenant/allergens
  create(data: { name: string; is_enabled?: boolean }): Observable<any> {
    return this.http.post<{ data: any }>(`${this.base}/allergens`, data).pipe(
      map(r => r.data ?? r)
    );
  }

  // Get allergen
  // GET /v1/tenant/allergens/{allergen}
  get(id: number): Observable<any> {
    return this.http.get(`${this.base}/allergens/${id}`);
  }

  // Update allergen
  // PUT /v1/tenant/allergens/{allergen}
  update(id: number, data: any): Observable<any> {
    return this.http.put(`${this.base}/allergens/${id}`, data);
  }

  // Delete allergen
  // DELETE /v1/tenant/allergens/{allergen}
  delete(id: number): Observable<any> {
    return this.http.delete(`${this.base}/allergens/${id}`);
  }

  // Restore a soft-deleted allergen
  // POST /v1/tenant/allergens/{allergen}/restore
  restore(id: number): Observable<any> {
    return this.http.post(`${this.base}/allergens/${id}/restore`, {});
  }

  // Bulk restore soft-deleted allergens
  // POST /v1/tenant/allergens/bulk-restore
  restoreBulk(data: any): Observable<any> {
    return this.http.post(`${this.base}/allergens/bulk-restore`, data);
  }
}
